import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Accordion from '@material-ui/core/ExpansionPanel';
import { Grid, TextField, Hidden, InputAdornment, Button, Typography } from "@material-ui/core";
import MuiAccordionSummary from '@material-ui/core/ExpansionPanelSummary';
import AccordionDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutline';
import { makeStyles } from "@material-ui/core/styles";
import { MenuItem } from "@material-ui/core";
import AddIcon from '@material-ui/icons/Add'
import { withStyles } from "@material-ui/core/styles";
import { grey200,grey300, red500 } from "material-ui/styles/colors";
import { RegexTextField } from "./_regexTextField";
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import moment from "moment";
import {cssuseStyles} from "../../e_billing-style"
import { useTranslation } from "react-i18next";
import { Skeleton } from '@material-ui/lab'
const useStyle = makeStyles((theme) => ({
    root: {
        width: "100%",
        paddingTop: 0,
    },
    textFieldStyling: {
        width: '90%',
        "& .MuiOutlinedInput-inputAdornedEnd": {
            paddingRight: "0%",
            paddingTop: "5%",
            paddingBottom: "0%",
            fontSize: "0.8rem"
        },
        "& .MuiOutlinedInput-input": {
            paddingLeft: "4%"
        },
        "& .MuiSvgIcon-root ": {
            fill: theme.palette.ePrimary?.base,
            fontSize: "1.1rem"
        },
        "& .MuiIconButton-root": {
            padding: "1px",
            paddingTop: "40%"
        },
        "& .MuiOutlinedInput-marginDense": {
            paddingBottom: "6%"
        },
        "& .MuiOutlinedInput-adornedEnd": {
            paddingRight: "0%"
        },
        "& .MuiFormHelperText-contained": {
            marginLeft: "0%",
        }
    },
    datepickrCustomize: {
        width: '90%',
        "& .MuiOutlinedInput-inputAdornedEnd": {
            paddingRight: "0px",
            paddingTop: "7px",
            paddingBottom: "0px",
            fontSize: "0.8rem"
        },
        "& .MuiOutlinedInput-input": {
            paddingLeft: "5px"
        },
        "& .MuiSvgIcon-root ": {
            fontSize: "1.1rem"
        },
        "& .MuiIconButton-root": {
            padding: "1px",
            paddingTop: "40%"
        },
        "& .MuiOutlinedInput-marginDense": {
            paddingBottom: "6%"
        },
        "& .MuiOutlinedInput-adornedEnd": {
            paddingRight: "0%"
        },
        "& .MuiFormHelperText-contained": {
            marginLeft: "0%",
        }
    },
    commentsFieldStyling: {
        width: "91%",
        overflow: 'auto !important', 
        height: "10vh !important",
        resize: 'vertical !important'
    },
    commentsStylingForMobile: {
        width: "100%",
        overflow: 'auto !important', 
        height: "8vh !important",
        resize: 'vertical !important'
    },
    mobileTextFieldStyling: {
        width: "100%"
    },
    deleteIconStyling: {
        marginLeft: '8px',
        color: theme.palette.ePrimary?.base
    },
    emptyAutoPayBgColor: {
        backgroundColor: grey200,
        width: '90%'
    },
    mobileEmptyAutoPayId: {
        backgroundColor: grey200,
        width: '100%'
    },
    
    requiredColor: {
        color: theme.palette.error
    },
    helperText: {
        marginLeft: "1px"
    },
    quaternaryColor: {
        color: theme.palette.ePrimary?.base,
    },
    dailogMenu: {
        background: theme.palette.ePrimary?.base,
        color: theme.palette.whiteColor.main,
        padding: "0px",
    },
    warningIcon: {
        color: theme.palette.eTertiary?.base
    },
    accordionHomeStyling: {
        boxShadow: "none",
        border: `2px solid ${grey300}`,
        margin: "0px",
        marginTop: "0px",
        marginBottom: "0px",
        
    },
    mobileAccordionHomeStyling: {
        boxShadow: "none",
        border: `2px solid ${grey300}`,
        margin: "0px",
        marginTop: "0px",
        marginBottom: "0px",
        width: "100%"
    },
    accordionDetailsStyling: {
        paddingLeft: "0px",
        paddingRight: "0px",
        paddingBottom: "0px",
        paddingTop: "0px",
        marginLeft: "6px",
    },
    bodyFields: {
        marginLeft: "4px",
        marginBottom: "13px"
    },
    titleFields: {
        marginLeft: "4px"
    },
    accordionSummaryStyling: {
        paddingLeft: "0px",
        paddingRight: "0px",
        marginLeft: "6px"
    },
    mobileAccordionSummary: {
        paddingLeft: "15px",
        paddingRight: "15px"
    },
    textFieldMaring: {
        marginTop: "5px",
        "& .MuiFormControl-root": {
            width: "100%"
        }
    },
    rotateIcon: {
        transform: "rotateX(180deg)"
    },
    lastRecordAP:{
        marginBottom:"7% !important"
    },
    lastRecordError:{
        marginBottom:"0% !important"
    }

}));
const AccordionSummary = withStyles({
    root: {
        "&.Mui-focused": {
            backgroundColor: "inherit"
        }
    }
})(MuiAccordionSummary);

const AutoPayAccordionComponent = (props) => {
    const classes = useStyle();
    const customStyles = cssuseStyles();
    const [expand, setExpand] = useState(false);
    const [valErrorAccount, setvalError] = useState(false);
    const [valErrorName, setValName] = useState(false)
    const [startDateErr, setStartDateErr] = useState(false)
    const [sourceIdErr, setSourceErr] = useState(false)
    const [expireErr, setExpireErr] = useState(false)
    const [valErrorLimit, setValErrLimit] = useState(false)
    const [record, setRecord] = useState(props?.info)
    const [lastRecord,setLastRecord]=useState(false)
    const [open, setOpen] = useState(false);
    const dateFormatAPI = useSelector(
        (state) => state?.parametersWidgets?.ParameterLookup?.YEAR_DATE_FORMAT
      );
      
      const dateFormatUI=useSelector(
          (state)=>state?.parametersWidgets?.ParameterLookup?.E_DATE_PICKER_FORMAT
      )
      
    const {
        info,
        accountId,
        recordsLenght,
        id_num,
        clickOnPlusButton,
        delteRecordFromUI,
        onChangeEnteredRecord,
        sourceCodeList,
        BANK_TEXT,
        CREDIT_CARD_TEXT,
        DEBIT_CARD_TEXT,
        VALIDATION_CONTENTS,
        AUTO_PAYMENT_DELETE_WARNING_TEXT,
        labels,
        onChange,
        expanded,
        paymentOptions,
        isInError,
        AUTOPAY_SINGLE_RECORD_DELETE_TEXT
    } = props;
    useEffect(() => {
        setRecord(props?.info)
    }, [props?.info, open])

    useEffect(()=>{
        if(recordsLenght && id_num && (id_num == (recordsLenght-1))){
            setLastRecord(true)
        }
    },[recordsLenght,id_num])

    const paymentMethods = [
        BANK_TEXT,
        CREDIT_CARD_TEXT,
        DEBIT_CARD_TEXT,
        props.info.autoPayMethod
    ];
    const onChangeField = (e) => {
        const { name, value } = e.target
        if (name === "startDate") {
            if (!value || value === "Invalid date") {
                setStartDateErr(true)
            }
            else {
                setStartDateErr(false)
            }
        }
        else if (name === "autopaySource") {
            if (!value) {
                setSourceErr(true)
            }
            else {
                setSourceErr(false)
            }
        }
        else if (name === "externalAccountId") {
            if (!value) {
                setvalError(true)
            }
            else {
                setvalError(false)
            }
        }
        else if (name === "expireDate") {
            if (!value) {
                setExpireErr(true)
            }
            else {
                setExpireErr(false)
            }
        }
        else if (name === "entityName") {
            if (!value) {
                setValName(true)
            }
            else {
                setValName(false)
            }
        }
        else if (name === "autopayMaxWithdrawalAmount") {
            if (parseFloat(value) > MAX_LIMIT_TENENT_CODE) {
                setValErrLimit(true)
            }
            else {
                setValErrLimit(false)
            }
        }
        setRecord({ ...record, [name]: value })
        let data = { ...record, [name]: value }
        onChangeEnteredRecord(data)
    }
    const toggleAcordion = () => {
        setExpand((prev) => !prev);        
    };

    const MAX_LIMIT_TENENT_CODE = useSelector(
        (state) => state?.parametersWidgets?.ParameterLookup?.AUTO_PAY_MAX_WITHDRAWAL_LIMIT
    );
    let deleteId = record.accountAutopayId;
    if (deleteId === undefined) {
        deleteId = record.uuid
    }
    const deleteRecord = () => {
        setOpen(false)
        delteRecordFromUI(accountId, deleteId)
    }
    const onCreateNewRecord = () => {
        clickOnPlusButton()
        setLastRecord(false)
    }

    const regexForNameField = /[^a-zA-Z\s]/gi;
    const regextForWithDrawal = /[^0-9.]/gi;
    const regexForExpireOn = /[^0-9/]/gi;
    const handleDailogBox = () => {
        setOpen(!open)
    }
    const displayConfirmationOnDelete = () => {
        setOpen(!open)
    }
    const{t:label, ready: labelReady} = useTranslation("label-NESCO_Customer_No_label")
    return (
        <>
            <Hidden mdDown>
                <Accordion expanded={expanded} className={classes.accordionHomeStyling} onChange={onChange}>
                    <AccordionSummary
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        className={classes.accordionSummaryStyling}
                    >
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <Grid container>
                                <Grid item lg={3} className={classes.titleFields}>
                                    <Typography variant="caption">
                                    {labels?.E_AUTOPAY_ID}
                                    </Typography>
                                    <TextField
                                        variant="outlined"
                                        disabled
                                        className={info.uuid ? classes.emptyAutoPayBgColor : classes.textFieldStyling}
                                        inputProps={{ className: customStyles.textFieldWidth }}
                                        value={record.accountAutopayId ? record.accountAutopayId : ""}
                                    />
                                </Grid>
                                <Grid item lg={4} className={classes.titleFields}>
                                <Typography variant="caption">
                                    {labels?.E_AUTOPAY_START_DATE} <span className={classes.requiredColor}>*</span>
                                   </Typography>
                                    <KeyboardDatePicker
                                        allowKeyboardControl
                                        autoOk={true}              
                                        disabled={record.status === "INACTIVE"}
                                        clearable={true}
                                        value={record.startDate}
                                        inputVariant="outlined"
                                        className={(record?.status === "ACTIVE" || record?.uuid )? classes.textFieldStyling : classes.datepickrCustomize}
                                        onChange={(date) => {
                                            let data = {
                                                target: {
                                                    name: "startDate",
                                                    value: date && moment(date).format(dateFormatAPI)
                                                }

                                            }
                                            onChangeField(data)

                                        }}
                                        size="small"
                                        format={dateFormatUI}
                                        placeholder={dateFormatUI}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                        error={startDateErr}
                                        onBlur={startDateErr}
                                        helperText={startDateErr ? VALIDATION_CONTENTS.start_date : null}
                                    />
                                </Grid>
                                <Grid item lg={4} className={classes.titleFields}>
                                    <Typography variant="caption">
                                        {labels?.E_AUTOPAY_END_DATE}
                                    </Typography>
                                    <KeyboardDatePicker
                                        allowKeyboardControl
                                        autoOk={true}
                                        disabled={record.status === "INACTIVE"}
                                        clearable={true}
                                        value={record.endDate}
                                        inputVariant="outlined"
                                        className={(record?.status === "ACTIVE" || record?.uuid )? classes.textFieldStyling : classes.datepickrCustomize}
                                        onChange={(e) => {
                                            let data = {
                                                target: {
                                                    name: "endDate",
                                                    value: e && moment(e).format(dateFormatAPI)
                                                }

                                            }
                                            onChangeField(data)

                                        }}
                                        size="small"
                                        format={dateFormatUI}
                                        placeholder={dateFormatUI}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                        error={false}
                                        onBlur={false}
                                        helperText={null}

                                    />
                                </Grid>
                                <ExpandMoreIcon fontSize="small" className={expanded && classes.rotateIcon}/>
                            </Grid>
                        </MuiPickersUtilsProvider>

                    </AccordionSummary>
                    <AccordionDetails className={classes.accordionDetailsStyling}>
                        <Grid container lg={12}>
                            <Grid item lg={3} className={classes.bodyFields}>
                                <Typography variant="caption">
                                    {labels?.E_AUTOPAY_METHOD}
                                </Typography>
                                <TextField
                                    variant="outlined"
                                    select
                                    className={classes.textFieldStyling}
                                    name="autoPayMethod"
                                    value={record.autoPayMethod}
                                    onChange={onChangeField}
                                    disabled={record.status === "INACTIVE"}
                                    inputProps={{ className: customStyles.textFieldWidth }}
                                >
                                    {paymentOptions?.getDropdownData?.map((value, index) => {
                                        return <MenuItem value={value?.dropDownValue} key={index}>{value?.dropDownValue}</MenuItem>;
                                    })}
                                </TextField>
                            </Grid>
                            <Grid item lg={4} className={classes.bodyFields}>
                                <Typography variant="caption">
                                    {labels?.E_AUTOPAY_SOURCE_CODE} <span className={classes.requiredColor}>*</span>
                                </Typography>
                                <TextField
                                    variant="outlined"
                                    select
                                    className={classes.textFieldStyling}
                                    disabled={record.status === "INACTIVE"}
                                    value={record.autopaySource}
                                    name="autopaySource"
                                    onChange={onChangeField}
                                    inputProps={{ className: customStyles.textFieldWidth }}
                                    error={sourceIdErr}
                                    onBlur={sourceIdErr}
                                    FormHelperTextProps={{
                                        className: classes.helperText
                                    }}
                                >
                                    {sourceCodeList.map((value, index) => {
                                        return <MenuItem value={value.autopaySrcCode} key={index}>{value.autopaySrcCode}</MenuItem>;
                                    })}
                                </TextField>
                            </Grid>
                            <Grid item lg={4} className={classes.bodyFields}>
                            {
                                labelReady ?
                                <Typography variant="caption">
                                    {record.autoPayMethod === BANK_TEXT ? label("N_CUSTOMER_NO") : labels?.E_AUTOPAY_CARD_NUMBER}<span className={classes.requiredColor}>*</span>
                                </Typography> : <Skeleton />
                            }
                                <TextField
                                    className={classes.textFieldStyling}
                                    type="text"
                                    inputProps={{ className: customStyles.textFieldWidth }}
                                    variant="outlined"
                                    disabled={record.status === "INACTIVE"}
                                    name="externalAccountId"
                                    value={record.externalAccountId}
                                    onChange={onChangeField}
                                    onBlur={valErrorAccount}
                                    error={valErrorAccount}
                                    FormHelperTextProps={{
                                        className: classes.helperText
                                    }}
                                    helperText={valErrorAccount && (record.autoPayMethod === BANK_TEXT ? VALIDATION_CONTENTS.account_number : (record.autoPayMethod && record.autoPayMethod !== BANK_TEXT ? VALIDATION_CONTENTS.card_number : null))}
                                />
                            </Grid>
                            <Grid item lg={3} className={classes.bodyFields}>
                                <Typography variant="caption">
                                    {labels?.E_AUTOPAY_EXPIRES_ON} {record.autoPayMethod !== BANK_TEXT && <span className={classes.requiredColor}>*</span>}
                               </Typography>
                                <RegexTextField
                                    regex={regexForExpireOn}
                                    disabled={record.status === "INACTIVE" || (record.autoPayMethod === "Bank")}
                                    className={classes.textFieldStyling}
                                    inputProps={{ className: customStyles.textFieldWidth }}
                                    placeholder='MM/YYYY'
                                    variant="outlined"
                                    value={record?.autoPayMethod !== BANK_TEXT ? record?.expireDate : ""}
                                    name="expireDate"
                                    onChange={onChangeField}
                                    error={expireErr}
                                    onBlur={expireErr}
                                    FormHelperTextProps={{
                                        className: classes.helperText
                                    }}
                                    helperText={(expireErr && (record.autoPayMethod !== BANK_TEXT)) ? VALIDATION_CONTENTS.expires_on : null}
                                />
                            </Grid>
                            <Grid item lg={4} className={classes.bodyFields}>
                                <Typography variant="caption">
                                    {labels?.E_AUTOPAY_NAME} <span className={classes.requiredColor}>*</span>
                                </Typography>
                                <RegexTextField
                                    regex={regexForNameField}
                                    disabled={record.status === "INACTIVE"}
                                    className={classes.textFieldStyling}
                                    variant="outlined"
                                    name="entityName"
                                    inputProps={{ className: customStyles.textFieldWidth }}
                                    onChange={onChangeField}
                                    value={record.entityName}
                                    error={valErrorName}
                                    onBlur={valErrorName}
                                    FormHelperTextProps={{
                                        className: classes.helperText
                                    }}
                                    helperText={valErrorName ? VALIDATION_CONTENTS.name : null}
                                />
                            </Grid>
                            <Grid item lg={4} className={classes.bodyFields}>
                                <Typography variant="caption">
                                    {labels?.E_AUTOPAY_MAX_WITHDRAWAL}
                                </Typography>
                                <RegexTextField
                                    regex={regextForWithDrawal}
                                    disabled={record.status === "INACTIVE"}
                                    className={classes.textFieldStyling}
                                    variant="outlined"
                                    name="autopayMaxWithdrawalAmount"
                                    value={record.autopayMaxWithdrawalAmount}
                                    onChange={onChangeField}
                                    inputProps={{ className: customStyles.textFieldWidth }}
                                    FormHelperTextProps={{
                                        className: classes.helperText
                                    }}
                                    error={valErrorLimit}
                                    onBlur={valErrorLimit}
                                    helperText={valErrorLimit ? `${VALIDATION_CONTENTS.limit} ${MAX_LIMIT_TENENT_CODE}` : null}
                                />
                            </Grid>
                            <Grid item lg={12} className={classes.bodyFields}>
                                <Typography variant="caption">
                                    {labels?.E_AUTOPAY_COMMENTS}
                                </Typography>
                                <TextareaAutosize
                                    disabled={record.status === "INACTIVE"}
                                    inputProps={{ readOnly: false }}
                                    variant="outlined"
                                    className={classes.commentsFieldStyling}
                                    name="comments"
                                    value={record.comments}
                                    onChange={onChangeField}
                                />
                            </Grid>
                        </Grid>


                    </AccordionDetails>
                </Accordion>
                <Dialog open={open} >
                    <DialogTitle id="customized-dialog-title" className={classes.dailogMenu}>
                        <span className={customStyles.dailogTitle}>{labels?.E_AUTOPAY_DELETE_CONFIRMATION_TITLE}</span>
                    </DialogTitle>
                    <DialogContent dividers>
                        <Grid container direction="column" justify="center" alignItems="center">
                            <Grid item>
                                <WarningRoundedIcon className={classes.warningIcon} />
                            </Grid>
                            <Grid item>
                                { recordsLenght === 1 ? AUTOPAY_SINGLE_RECORD_DELETE_TEXT : AUTO_PAYMENT_DELETE_WARNING_TEXT }
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleDailogBox} className={customStyles.warningCancelButtonStyling}><b>{labels?.E_AUTOPAY_CANCEL_BUTTON_TITLE}</b></Button>
                        <Button onClick={deleteRecord} className={customStyles.warningSaveButtonStyling}>{labels?.E_AUTOPAY_DELETE_CONFIRMATION_OK_BUTTON}</Button>
                    </DialogActions>


                </Dialog>
                <Grid container className={lastRecord ?
                    isInError?
                    classes.lastRecordError
                    :
                    classes.lastRecordAP
                    :
                    null} justify="flex-end">
                    <Grid item>
                        {
                            (recordsLenght - 1 === id_num) ? <DeleteOutlinedIcon color={classes.quaternaryColor} onClick={displayConfirmationOnDelete} cursor="pointer" className={classes.deleteIconStyling} disabled={true} /> : <DeleteOutlinedIcon onClick={displayConfirmationOnDelete} cursor="pointer" className={classes.deleteIconStyling} />
                        }
                    </Grid>
                    <Grid item>
                        {
                            (recordsLenght - 1 === id_num) && <AddIcon className={classes.deleteIconStyling} cursor="pointer" onClick={onCreateNewRecord} />
                        }
                    </Grid>
                </Grid>
            </Hidden>
            <Hidden lgUp>
                <Accordion expanded={expanded} className={classes.mobileAccordionHomeStyling} onChange={onChange}>
                    <AccordionSummary className={classes.mobileAccordionSummary}>
                        <Grid container direction="column">
                            <Grid item className={classes.textFieldMaring}>
                            {labels?.E_AUTOPAY_ID}
                                <TextField
                                    className={info.uuid ? classes.mobileEmptyAutoPayId : classes.mobileTextFieldStyling}
                                    disabled
                                    fullWidth
                                    value={record.accountAutopayId ? record.accountAutopayId : ""}
                                    variant="outlined"
                                />
                            </Grid>

                            <Grid item className={classes.textFieldMaring}>
                                {labels?.E_AUTOPAY_START_DATE} <span className={classes.requiredColor}>*</span>
                                <MuiPickersUtilsProvider utils={DateFnsUtils} >
                                    <KeyboardDatePicker
                                        allowKeyboardControl
                                        autoOk={true}
                                        disabled={record.status === "INACTIVE"}
                                        clearable={true}
                                        value={record.startDate}
                                        inputVariant="outlined"
                                        onChange={(e) => {
                                            let data = {
                                                target: {
                                                    name: "startDate",
                                                    value: e && moment(e).format(dateFormatAPI)
                                                }

                                            }
                                            onChangeField(data)

                                        }}
                                        
                                        format={dateFormatUI}
                                        placeholder={dateFormatUI}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                        error={startDateErr}
                                        onBlur={startDateErr}

                                        helperText={startDateErr ? VALIDATION_CONTENTS.start_date : null}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item className={classes.textFieldMaring}>
                                {labels?.E_AUTOPAY_END_DATE}
                                <MuiPickersUtilsProvider utils={DateFnsUtils} >
                                    <KeyboardDatePicker
                                        allowKeyboardControl
                                        autoOk={true}
                                        disabled={record.status === "INACTIVE"}
                                        clearable={true}
                                        value={record.endDate}
                                        inputVariant="outlined"
                                        onChange={(e) => {
                                            let data = {
                                                target: {
                                                    name: "endDate",
                                                    value: e && moment(e).format(dateFormatAPI)
                                                }

                                            }
                                            onChangeField(data)

                                        }}
                                        format={dateFormatUI}
                                        placeholder={dateFormatUI}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                        error={false}
                                        onBlur={false}
                                        helperText={null}

                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item className={classes.textFieldMaring}>
                                {labels?.E_AUTOPAY_METHOD}
                                <TextField
                                    value={record.autoPayMethod}
                                    variant="outlined"
                                    select
                                    className={classes.mobileTextFieldStyling}
                                    disabled={record.status === "INACTIVE"}
                                    name="autoPayMethod"
                                    onChange={onChangeField}
                                >
                                    {paymentOptions?.getDropdownData?.map((value, index) => {
                                        return <MenuItem value={value.dropDownValue} key={index}>{value.dropDownValue}</MenuItem>;
                                    })}
                                </TextField>
                            </Grid>
                            <Grid item className={classes.textFieldMaring}>
                                {labels?.E_AUTOPAY_SOURCE_CODE} <span className={classes.requiredColor}>*</span>
                                <TextField
                                    variant="outlined"
                                    select
                                    className={classes.mobileTextFieldStyling}
                                    disabled={record.status === "INACTIVE"}
                                    value={record.autopaySource}
                                    name="autopaySource"
                                    error={sourceIdErr}
                                    onBlur={sourceIdErr}
                                    onChange={onChangeField}
                                    FormHelperTextProps={{
                                        className: classes.helperText
                                    }}
                                >
                                    {sourceCodeList.map((value, index) => {
                                        return <MenuItem value={value.autopaySrcCode} key={index}>{value.autopaySrcCode}</MenuItem>;
                                    })}
                                </TextField>
                            </Grid>
                            <Grid item className={classes.textFieldMaring}>
                            <>
                                {
                                    labelReady ?
                                    <>
                                    {record.autoPayMethod === BANK_TEXT ? label("N_CUSTOMER_NO") : labels?.E_AUTOPAY_CARD_NUMBER} <span className={classes.requiredColor}>*</span>
                                    </>
                                    : <Skeleton />
                                }
                            </>
                                <TextField
                                    disabled={record.status === "INACTIVE"}
                                    className={classes.mobileTextFieldStyling}
                                    type="text"
                                    inputProps={{ readOnly: false }}
                                    variant="outlined"
                                    name="externalAccountId"
                                    value={record.externalAccountId}
                                    error={valErrorAccount}
                                    onBlur={valErrorAccount}
                                    onChange={onChangeField}
                                    FormHelperTextProps={{
                                        className: classes.helperText
                                    }}
                                    helperText={valErrorAccount && (record.autoPayMethod === BANK_TEXT ? VALIDATION_CONTENTS.account_number : (record.autoPayMethod && record.autoPayMethod !== BANK_TEXT ? VALIDATION_CONTENTS.card_number : null))}
                                />
                            </Grid>
                            <Grid item>
                                <Grid container direction="row" justify="space-between">
                                    <Grid item >
                                        <ExpandMoreIcon className={expanded && classes.rotateIcon}/>
                                    </Grid>
                                    <Grid item>
                                        <DeleteOutlinedIcon onClick={handleDailogBox} cursor="pointer" />
                                    </Grid>
                                    {
                                        (recordsLenght - 1 === id_num) && <AddIcon onClick={onCreateNewRecord} cursor="pointer" />
                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                    </AccordionSummary>
                    <AccordionDetails className={classes.mobileAccordionSummary}>
                        <Grid container direction="column">
                            <Grid item className={classes.textFieldMaring}>
                                {labels?.E_AUTOPAY_EXPIRES_ON} {record.autoPayMethod !== BANK_TEXT && <span className={classes.requiredColor}>*</span>}
                                <RegexTextField
                                    regex={regexForExpireOn}
                                    disabled={record.status === "INACTIVE" || (record.autoPayMethod === BANK_TEXT)}
                                    className={classes.mobileTextFieldStyling}
                                    inputProps={{ readOnly: false }}
                                    placeholder='MM/YYYY'
                                    variant="outlined"
                                    error={expireErr}
                                    onBlur={expireErr}
                                    value={record?.autoPayMethod !== BANK_TEXT ? record.expireDate : ""}
                                    name="expireDate"
                                    onChange={onChangeField}
                                    FormHelperTextProps={{
                                        className: classes.helperText
                                    }}
                                    helperText={(expireErr && (record.autoPayMethod !== BANK_TEXT)) ? VALIDATION_CONTENTS.expires_on : null}
                                />
                            </Grid>
                            <Grid item className={classes.textFieldMaring}>
                                {labels?.E_AUTOPAY_NAME} <span className={classes.requiredColor}>*</span>
                                <RegexTextField
                                    regex={regexForNameField}
                                    disabled={record.status === "INACTIVE"}
                                    className={classes.mobileTextFieldStyling}
                                    inputProps={{ readOnly: false }}
                                    variant="outlined"
                                    name="entityName"
                                    value={record.entityName}
                                    error={valErrorName}
                                    onBlur={valErrorName}
                                    onChange={onChangeField}
                                    FormHelperTextProps={{
                                        className: classes.helperText
                                    }}
                                    helperText={valErrorName ? VALIDATION_CONTENTS.name : null}
                                />

                            </Grid>
                            <Grid item className={classes.textFieldMaring}>
                                {labels?.E_AUTOPAY_MAX_WITHDRAWAL}
                                <RegexTextField
                                    regex={regextForWithDrawal}
                                    disabled={record.status === "INACTIVE"}
                                    className={classes.mobileTextFieldStyling}
                                    inputProps={{ readOnly: false }}
                                    variant="outlined"
                                    name="autopayMaxWithdrawalAmount"
                                    value={record.autopayMaxWithdrawalAmount}
                                    onChange={onChangeField}
                                    FormHelperTextProps={{
                                        className: classes.helperText
                                    }}
                                    error={valErrorLimit}
                                    onBlur={valErrorLimit}
                                    helperText={valErrorLimit ? `${VALIDATION_CONTENTS.limit} ${MAX_LIMIT_TENENT_CODE}` : null}
                                />
                            </Grid>
                            <Grid item className={classes.textFieldMaring}>
                                {labels?.E_AUTOPAY_COMMENTS}
                                <TextareaAutosize
                                    disabled={record.status === "INACTIVE"}
                                    inputProps={{ readOnly: false }}
                                    variant="outlined"
                                    className={classes.commentsStylingForMobile}
                                    name="comments"
                                    value={record.comments}
                                    onChange={onChangeField}
                                />
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                </Accordion>
                <Dialog open={open} >
                    <DialogTitle id="customized-dialog-title" className={classes.dailogMenu}>
                        <span className={customStyles.dailogTitle}>{labels?.E_AUTOPAY_DELETE_CONFIRMATION_TITLE}</span>
                    </DialogTitle>
                    <DialogContent dividers>
                        <Grid container direction="column" justify="center" alignItems="center">
                            <Grid item>
                                <WarningRoundedIcon className={classes.warningIcon} />
                            </Grid>
                            <Grid item>
                                {recordsLenght === 1 ? AUTOPAY_SINGLE_RECORD_DELETE_TEXT : AUTO_PAYMENT_DELETE_WARNING_TEXT }
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleDailogBox} className={customStyles.warningCancelButtonStyling}>{labels?.E_AUTOPAY_CANCEL_BUTTON_TITLE}</Button>
                        <Button onClick={deleteRecord} className={customStyles.warningSaveButtonStyling}>{labels?.E_AUTOPAY_DELETE_CONFIRMATION_OK_BUTTON}</Button>
                    </DialogActions>


                </Dialog>
            </Hidden>
        </>
    )
}
export default AutoPayAccordionComponent